import {useState} from 'react'
import {DebounceInput} from 'react-debounce-input'
import {useIntl} from 'react-intl'

import BreadCrumb from 'src/_metronic/layout/components/breadcrumb'
import TerminalList from '../component/List'
import Export from '../component/List/Export'
import FilterDrawer from '../component/List/FilterDrawer'

import {useGetList} from '../context/useQuery'
import {useTerminal} from '../hook'

function Dashboard() {
  const intl = useIntl()
  const {isLoading} = useGetList()
  const {listFilter, listFilterSet} = useTerminal()

  const [search, setSearch] = useState('')
  const tableName = 'terminals'

  return (
    <>
      <BreadCrumb currentPage={intl.formatMessage({id: 'TERMINAL_PLURAL'})} />
      <div className='d-flex flex-column flex-root' id='kt_app_root'>
        <div className='card mt-10'>
          <div className='card-header border-0 pt-6'>
            <div className='card-title'>
              <div className='d-flex align-items-center position-relative my-1'>
                <i className='ki-outline ki-magnifier fs-3 position-absolute ms-5'></i>
                <DebounceInput
                  debounceTimeout={500}
                  type='text'
                  className='form-control form-control-solid w-250px ps-13'
                  placeholder={intl.formatMessage({id: 'GLOBAL.FILTER.SEARCH'})}
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value)
                    listFilterSet({
                      ...listFilter,
                      paging: {
                        ...listFilter.paging,
                        currentPageNumber: 1,
                      },
                      filterList: [
                        {
                          key: '_id',
                          operator: 14,
                          logicalOp: 2,
                          value: [e.target.value],
                          childFilters: [],
                        },
                      ],
                    })
                  }}
                />
              </div>
            </div>
            <div className='card-toolbar'>
              <div className='d-flex justify-content-end' data-kt-customer-table-toolbar='base'>
                <div className='d-flex align-items-center gap-2 gap-lg-3'>
                  <a type='button' className='btn btn-light' href='terminals/new-terminal'>
                    <i className='bi bi-plus-circle-fill fs-2'>
                      <span className='path1'></span>
                      <span className='path2'></span>
                    </i>
                  </a>
                  <button
                    className='btn btn-light'
                    data-bs-toggle='tooltip'
                    data-bs-placement='left'
                    data-bs-dismiss='click'
                    data-bs-trigger='hover'
                    id='kt_filter_toggle'
                  >
                    <i className='bi bi-sliders fs-4 me-4'></i>
                    {intl.formatMessage({id: 'GLOBAL.FILTER'})}
                  </button>
                  <FilterDrawer
                    filter={listFilter.filterList}
                    search={search}
                    setSearch={setSearch}
                    setFilter={(value: any) => {
                      listFilterSet({
                        ...listFilter,
                        filterList: value,
                        paging: {
                          ...listFilter.paging,
                          currentPageNumber: 1,
                        },
                      })
                    }}
                  />

                  <Export tableName={tableName} />
                </div>
              </div>
            </div>
          </div>
          <div className='card-body pt-10'>
            <TerminalList loading={isLoading} />
          </div>
        </div>
      </div>
    </>
  )
}

export default Dashboard
